module.exports = __webpack_public_path__ + "img/cr.6227e254.png";